/**
 * 模块: 趋势分析筛选面板
 * 职责: 提供指标、周期选择和统计显示
 * 限制: 文件<280行
 */

import React from 'react';
import { Card, Checkbox, Space, Select, DatePicker, Button } from 'antd';
import type { Dayjs } from 'dayjs';
import type { Period } from '../../types';
import { AVAILABLE_METRICS } from './constants';

const { Option } = Select;
const { RangePicker } = DatePicker;

interface TrendFiltersProps {
  selectedMetrics: string[];
  selectedPeriods: string[];
  periods: Period[];
  dateRange: [Dayjs, Dayjs] | null;
  trendDataLength: number;
  onMetricChange: (values: string[]) => void;
  onPeriodChange: (values: string[]) => void;
  onDateRangeChange: (dates: [Dayjs | null, Dayjs | null] | null) => void;
  onSelectAllPeriods: () => void;
}

export const TrendFilters: React.FC<TrendFiltersProps> = ({
  selectedMetrics,
  selectedPeriods,
  periods,
  dateRange,
  trendDataLength,
  onMetricChange,
  onPeriodChange,
  onDateRangeChange,
  onSelectAllPeriods,
}) => {
  return (
    <>
      <Card title="选择指标" className="filter-card">
        <Checkbox.Group
          value={selectedMetrics}
          onChange={onMetricChange}
          style={{ width: '100%' }}
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            {AVAILABLE_METRICS.map((metric) => (
              <Checkbox key={metric.key} value={metric.key}>
                {metric.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </Card>

      <Card title="选择周期" className="filter-card" style={{ marginTop: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <RangePicker
            style={{ width: '100%' }}
            value={dateRange}
            onChange={onDateRangeChange}
            placeholder={['开始日期', '结束日期']}
          />

          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="选择周期"
            value={selectedPeriods}
            onChange={onPeriodChange}
            maxTagCount="responsive"
          >
            {periods.map((period) => (
              <Option key={period.id} value={period.id.toString()}>
                {period.week_number}
              </Option>
            ))}
          </Select>

          <Button
            type="link"
            size="small"
            onClick={onSelectAllPeriods}
          >
            选择全部
          </Button>
        </Space>
      </Card>

      <Card title="数据统计" className="stats-card" style={{ marginTop: 16 }}>
        <div className="stat-item">
          <span className="stat-label">选中周期：</span>
          <span className="stat-value">{selectedPeriods.length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">选中指标：</span>
          <span className="stat-value">{selectedMetrics.length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">数据点：</span>
          <span className="stat-value">{trendDataLength}</span>
        </div>
      </Card>
    </>
  );
};

